import EpisodeOfCareEvent from './EpisodeOfCareEvent';

export default EpisodeOfCareEvent;
